export default __webpack_public_path__ + "f2d16e54d1ded6f2cc882d86b10d4710.png";